import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.companyCatalogListing || initialState;

export const selectSummaryData = createSelector(
  [selectDomain],
  (state) => state.summaryData
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectCompanyCount = createSelector(
  [selectDomain],
  (state) => state.companyCount
);
